import { render } from "./Verify.vue?vue&type=template&id=d28cfe00&ts=true"
import script from "./Verify.vue?vue&type=script&lang=ts"
export * from "./Verify.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__